module.exports = __webpack_public_path__ + "person.png";


//////////////////
// WEBPACK FOOTER
// ./src/data/assets/img/person.png
// module id = 2191
// module chunks = 13